// Branche la maquette sur Shopify : paiement réel, formulaires réels, compte réel.
(() => {
  const COLOR = { noir: 'Black', blanc: 'White', marine: 'Navy', rose: 'Light Pink', ciel: 'Light Blue', rouge: 'Red', sable: 'Sand' };
  const SOON = ['custom', 'body-count'];
  const key = i => BY_SLUG[i.s].options ? `${i.s}--${i.o}` : i.s;

  const add = Cart.add;
  Cart.add = function (s, ...rest) {
    if (SOON.includes(s)) { toast('Bientôt disponible.'); return false; }
    return add.call(this, s, ...rest);
  };
  Cart.items = Cart.items.filter(i => !SOON.includes(i.s));
  Cart.tip = 0; Cart.sync();

  async function allProducts() {
    const all = [];
    for (let page = 1; page < 10; page++) {
      const r = await fetch(`/products.json?limit=250&page=${page}`);
      if (!r.ok) throw new Error('products');
      const { products } = await r.json();
      all.push(...products);
      if (products.length < 250) break;
    }
    return all;
  }

  // Ne renvoie jamais un article approchant : sans correspondance exacte, le paiement est refusé.
  function variantOf(i, products) {
    const titles = TM_TITLES[key(i)];
    const title = titles && (i.l ? titles.logo : titles.base);
    const p = title && products.find(x => x.title === title);
    if (!p) return null;
    return p.variants.find(v => {
      const parts = v.title.split(' / ');
      return parts.includes(COLOR[i.c]) && parts.includes(i.z) && v.available;
    }) || null;
  }

  let busy = false;
  async function checkout() {
    if (busy) return;
    if (!Cart.items.length) { go('boutique'); return; }
    busy = true; toast('Préparation du paiement…');
    try {
      const products = await allProducts();
      const lines = Cart.items.map(i => ({ i, v: variantOf(i, products) }));
      const miss = lines.find(l => !l.v);
      if (miss) {
        toast(`« ${BY_SLUG[miss.i.s].name} » n’est plus disponible dans ce coloris ou cette taille.`);
        busy = false; return;
      }
      const qty = new Map();
      lines.forEach(({ i, v }) => qty.set(v.id, (qty.get(v.id) || 0) + i.q));
      const path = [...qty].map(([id, q]) => `${id}:${q}`).join(',');
      const code = Cart.promo && welcomeLeft() > 0 ? `?discount=${encodeURIComponent(Cart.promo)}` : '';
      location.href = `/cart/${path}${code}`;
    } catch (e) {
      toast('Le paiement n’a pas pu démarrer. Réessaie dans un instant.');
      busy = false;
    }
  }

  document.addEventListener('click', e => {
    const a = e.target.closest('a[href="#commande"]');
    if (a) { e.preventDefault(); e.stopPropagation(); checkout(); }
  }, true);

  const redirect = () => {
    if (location.hash === '#compte' || location.hash === '#suivi') location.replace('/account');
    if (location.hash === '#commande') { history.replaceState(null, '', '#boutique'); checkout(); }
  };
  addEventListener('hashchange', redirect); redirect();

  async function post(data) {
    const body = new URLSearchParams({ form_type: data['contact[tags]'] ? 'customer' : 'contact', utf8: '✓', ...data });
    const r = await fetch('/contact', { method: 'POST', body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
    return r.ok;
  }

  document.addEventListener('submit', async e => {
    const f = e.target.closest('.sf');
    if (!f) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const kind = f.dataset.form, fd = new FormData(f), er = f.querySelector('[data-err]');
    const mail = Guard.clean(fd.get('email') || '', 200), msg = Guard.clean(fd.get('msg') || '');
    const fail = m => { er.className = 'err'; er.textContent = m; };
    const g = Guard.check(f, kind); if (g) return fail(g);
    if (kind === 'suivi') { location.href = '/account'; return; }
    if (kind === 'idee' ? msg.length < 3 : !Guard.email(mail)) return fail(kind === 'idee' ? 'Écris ta phrase.' : 'Cette adresse e-mail ne semble pas valide.');
    if (kind === 'contact' && (!Guard.clean(fd.get('name') || '', 80) || !msg)) return fail('Merci de remplir ton nom et ton message.');
    const data = kind === 'news'
      ? { 'contact[email]': mail, 'contact[tags]': 'newsletter', 'contact[accepts_marketing]': 'true' }
      : { 'contact[email]': mail || 'idee@trustmind.store', 'contact[name]': Guard.clean(fd.get('name') || '', 80) || 'Idée de phrase', 'contact[body]': msg };
    try {
      if (!await post(data)) throw 0;
      Guard.commit(kind); f.reset(); er.className = 'ok';
      er.textContent = kind === 'news' ? 'Merci, c’est noté.' : kind === 'idee' ? 'Merci, on la lit.' : 'Merci, on te répond vite.';
    } catch (x) { fail('L’envoi a échoué. Réessaie dans un instant.'); }
  }, true);
})();
